// Borrado de objetos / marca de agua en video — los CUATRO webhooks n8n
// (`sam2_erase_start/status` con points, `bria_erase_start/status` sin
// points para marca de agua) se unifican en atlas `/v1/videos/erase/start` y
// `/v1/videos/erase/status` (ADR-601): el backend distingue por la presencia
// de `points`. Flag ADENTRO:
//   ON  → atlas con JWT (`user_id`/`company_id` NO viajan). Start
//         `{response:'success', jobId}`, status `{status:'done'|'processing'
//         |'error', storagePath?, error?}` — shapes idénticos a n8n.
//   OFF → cada sabor vuelve a SU par de webhooks n8n byte-idéntico.

import {
  BRIA_ERASE_START_URL,
  BRIA_ERASE_STATUS_URL,
  GENERATE_AUTH_TOKEN,
  SAM2_ERASE_START_URL,
  SAM2_ERASE_STATUS_URL,
  USE_ATLAS_BACKEND,
} from '../config';
import { atlasBackendFetch } from './atlasBackend';

/** Sabor del borrado — SOLO elige el par de webhooks del fallback n8n. */
export type EraseFlavor = 'sam2' | 'bria';

export interface VideoEraseStartBody {
  user_id: string;
  company_id: string;
  project_id: string;
  clip_id: string;
  video_url: string;
  duration_sec: number;
  /** Marcas SAM2; ausente = marca de agua (ex bria). */
  points?: Array<{ x: number; y: number; label: 0 | 1 }>;
  frame_width?: number;
  frame_height?: number;
  prompt?: string;
  modo_utilizado?: string;
}

/** Devuelve el Response CRUDO — los callers ya manejan raw/text/status. */
export async function postVideoEraseStart(
  flavor: EraseFlavor,
  body: VideoEraseStartBody,
): Promise<Response> {
  if (USE_ATLAS_BACKEND) {
    const { user_id: _u, company_id: _c, ...atlasBody } = body;
    return atlasBackendFetch('/v1/videos/erase/start', atlasBody, {
      signal: AbortSignal.timeout(60_000),
    });
  }
  const url = flavor === 'sam2' ? SAM2_ERASE_START_URL : BRIA_ERASE_START_URL;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
    },
    body: JSON.stringify(body),
    signal: AbortSignal.timeout(60_000),
  });
}

export async function postVideoEraseStatus(
  flavor: EraseFlavor,
  body: { job_id: string; project_id: string; company_id: string },
): Promise<Response> {
  if (USE_ATLAS_BACKEND) {
    const { company_id: _c, ...atlasBody } = body;
    return atlasBackendFetch('/v1/videos/erase/status', atlasBody, {
      signal: AbortSignal.timeout(60_000),
    });
  }
  const url = flavor === 'sam2' ? SAM2_ERASE_STATUS_URL : BRIA_ERASE_STATUS_URL;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
    },
    body: JSON.stringify(body),
    signal: AbortSignal.timeout(60_000),
  });
}
